import { useEffect, useRef } from 'react'
import { isMobile } from 'react-device-detect'
import { useAudioInputs, useAudioOutputs, useMeetingManager, useVideoInputs } from 'amazon-chime-sdk-component-library-react'
import { DeviceType } from 'amazon-chime-sdk-component-library-react/lib/types'

import { rejectDefaultDevices } from '@/utils/devices'

/**
 * Select default chime device
 */
export const useNonDefaultDeviceChime = () => {
  const meetingManager = useMeetingManager()
  const { devices: audioInputDevices } = useAudioInputs()
  const { devices: audioOutputDevices } = useAudioOutputs()
  const { devices: videoInputDevices } = useVideoInputs()

  const isAudioInputDeviceSelectedFirstTime = useRef<boolean>(false)
  const isAudioOutputDeviceSelectedFirstTime = useRef<boolean>(false)
  const isVideoInputDeviceSelectedFirstTime = useRef<boolean>(false)

  useEffect(() => {
    async function selectDevice(devices: DeviceType[], type: MediaDeviceKind) {
      if (!devices.length) return
      devices = rejectDefaultDevices<DeviceType>(devices)
      try {
        switch (type) {
          case 'audioinput':
            if (!isAudioInputDeviceSelectedFirstTime.current) {
              await meetingManager.startAudioInputDevice(devices[0].deviceId)
              isAudioInputDeviceSelectedFirstTime.current = true
            }
            break
          case 'audiooutput':
            if (!isAudioOutputDeviceSelectedFirstTime.current) {
              await meetingManager.startAudioOutputDevice(devices[0].deviceId)
              isAudioOutputDeviceSelectedFirstTime.current = true
            }
            break
          case 'videoinput':
            if (!isVideoInputDeviceSelectedFirstTime.current) {
              await meetingManager.startVideoInputDevice(isMobile ? { facingMode: 'front' } : devices[0].deviceId)
              isVideoInputDeviceSelectedFirstTime.current = true
            }
            break
          default:
            break
        }
      } catch (error) {
        if (devices.length > 1) {
          console.log(`Failed to select ${devices[0].label} device`, error)
        } else {
          console.log('No webcam to access')
        }
      }
    }

    selectDevice(audioInputDevices, 'audioinput')
    selectDevice(audioOutputDevices, 'audiooutput')
    selectDevice(videoInputDevices, 'videoinput')
  }, [audioInputDevices, audioOutputDevices, videoInputDevices, meetingManager])

  return {}
}
